import { msalInstance } from '../index';
import { loginRequest } from '../authConfig';

export async function getToken(scope) {
    let token = null;
    let account = msalInstance.getActiveAccount();
    if (!account) {
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0) {
            account = accounts[0];
            msalInstance.setActiveAccount(account);
        }
    }
    if (!account) {
        await msalInstance.loginRedirect();
        return null;
    }
    var request = {
        scopes: loginRequest.scopes,
        account: account
    }
    if (scope === 'graph') {
        request = {
            scopes: ['User.Read'],
            account: account
        }
    }

    await msalInstance.acquireTokenSilent(request).then(response => {
        token = response.accessToken;
    }).catch(err => {
        console.log('GetTokenSilent failed, using redirect');
        if (err?.name === 'InteractionRequiredAuthError' || err?.errorCode === 'monitor_window_timeout') {
            return msalInstance.acquireTokenRedirect(request).then(response => {
                token = response.accessToken;
                console.log('acquiretokenredirect: ' + token);
            });
        }
    });

    return token;
}

export function getUsername() {
    let account = msalInstance.getActiveAccount();
    if (!account) {
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0) {
            account = accounts[0];
        }
    }
    return account?.username ?? null;
}